/**
 * Custom PropTypes validator for onClick prop
 * Ensures that at least one of 'to', 'href', or 'onClick' is provided
 *
 * @param {object} props - Component props
 * @param {string} propName - Name of the prop being validated
 * @param {string} componentName - Name of the component
 * @returns {Error|null} - Error if validation fails, null otherwise
 */
export const onClickPropValidator = (props, propName, componentName) => {
  if (!props.to && !props.href && !props.onClick) {
    return new Error(
      `One of 'to', 'href', or 'onClick' is required in '${componentName}'.`
    );
  }
  if (props.onClick && typeof props.onClick !== 'function') {
    return new Error(
      `Invalid prop '${propName}' supplied to '${componentName}'. Expected a function.`
    );
  }
  return null;
};
